// separate config module for easier refactoring,
// ability to add comments,
// and setting of default values

const config = {
  api: {
    url: process.env.REACT_APP_API_URL,
    // url: "http://localhost:3001" //for local testing
    redirect: process.env.REACT_APP_API_REDIRECT,
  },

  internalAppsList: [
    // "d521979c-6a5c-46e5-b9cb-798a2f74521b", // pbb-stg
    "d5417b86-01f4-4df0-a05b-3e5a0754a099", // one-peso-stg
    "3a824535-fdd3-44b0-9b4b-cb5211551aa1", // one-peso-prod
  ],
}

export default config
